import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let SignatureDesign = class SignatureDesign extends Vue {
    // @Prop({default:{}})
    // opts!:any
    render(h) {
        const that = this;
        return h('a-textarea', { props: {
                disabled: true,
                placeholder: that.$t('cloudpivot.form.dataitem.InputPlaceholder').toString(),
            } });
    }
};
SignatureDesign = tslib_1.__decorate([
    Component({ name: 'SignatureDesign' })
], SignatureDesign);
export default SignatureDesign;
